import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import JSZip from 'jszip'; // Add this package: npm install jszip
import { saveAs } from 'file-saver'; // Add this package: npm install file-saver
import { adminAPI } from '../api/admin.api';
import toast from 'react-hot-toast';
import {
  Box,
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Chip,
  Avatar,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  Toolbar,
  Tooltip,
  Card,
  CardContent,
  Divider,
  Stack,
  CircularProgress,
  InputAdornment,
  AppBar,
} from '@mui/material';
import {
  Search,
  Visibility,
  GetApp,
  FilterList,
  CheckCircle,
  Cancel,
  ChevronLeft,
  ChevronRight,
  Image,
  Person,
  Email,
  Phone,
  LocationOn,
  CreditCard,
  CalendarToday,
  Close,
  Download,
  Edit,
  MedicalServices,
  Delete,
  ThumbUp,
  ThumbDown,
} from '@mui/icons-material';

const AthletesList = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isAdmin, logout } = useAuth();
  const [athletes, setAthletes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [exporting, setExporting] = useState(false);
  const [selectedAthlete, setSelectedAthlete] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [selectedAthletes, setSelectedAthletes] = useState([]);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [verificationNotes, setVerificationNotes] = useState('');
  const [medicalAge, setMedicalAge] = useState('');
  const [updatingMedicalAge, setUpdatingMedicalAge] = useState(false);
  const [editingAthlete, setEditingAthlete] = useState(false);
  const [editFormData, setEditFormData] = useState({});
// Add these state variables after existing useState declarations
const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
const [deleteAthleteId, setDeleteAthleteId] = useState(null);
const [deleting, setDeleting] = useState(false);
  const [pagination, setPagination] = useState({});
  const [searchInput, setSearchInput] = useState('');
  // Add these state variables after the existing useState declarations
const [events, setEvents] = useState([]);
const [states] = useState([
  'All States',
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
  'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
  'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
  'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry'
]);
const [downloadingInvoices, setDownloadingInvoices] = useState(false);

// Update the filters state initialization
const [filters, setFilters] = useState({
  registrationType: 'all',
  verificationStatus: 'all',
  paymentStatus: 'completed',
  state: 'all',
  eventId: 'all',
  startDate: '', // Changed from null to empty string
  endDate: '', // Changed from null to empty string
  search: '',
  page: 1,
  limit: 20,
  sortBy: 'createdAt',
  sortOrder: 'desc',
});

// Add useEffect to fetch events
useEffect(() => {
  const fetchEvents = async () => {
    try {
      const response = await fetch('https://register.iwlf.in/api/events', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      const data = await response.json();
      if (data.success) {
        setEvents(data.data);
      }
    } catch (error) {
      console.error('Error fetching events:', error);
    }
  };
  fetchEvents();
}, []);

useEffect(() => {
  if (!isAuthenticated || !isAdmin) {
    navigate('/admin/login');
    return;
  }
  fetchAthletes();
}, [isAuthenticated, isAdmin, navigate, filters]);


  const fetchAthletes = async () => {
    setLoading(true);
    try {
      const response = await adminAPI.getAllAthletes(filters);
      setAthletes(response.data);
      setPagination(response.pagination);
    } catch (error) {
      toast.error('Failed to load athletes');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setFilters({ ...filters, search: searchInput, page: 1 });
  };

  const handleFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value, page: 1 });
  };

  const handleViewDetails = async (athleteId) => {
    try {
      const response = await adminAPI.getAthleteDetails(athleteId);
      setSelectedAthlete(response.data);
      setMedicalAge(response.data.medicalAge || '');
      setShowModal(true);
    } catch (error) {
      toast.error('Failed to load athlete details');
    }
  };

  // Add function to download invoices in bulk
// const handleDownloadInvoices = async () => {
//   setDownloadingInvoices(true);
//   try {
//     const queryParams = new URLSearchParams();
//     if (filters.registrationType !== 'all') queryParams.append('registrationType', filters.registrationType);
//     if (filters.verificationStatus !== 'all') queryParams.append('verificationStatus', filters.verificationStatus);
//     if (filters.paymentStatus !== 'all') queryParams.append('paymentStatus', filters.paymentStatus);
//     if (filters.state !== 'all') queryParams.append('state', filters.state);
//     if (filters.eventId !== 'all') queryParams.append('eventId', filters.eventId);
//     if (filters.startDate) queryParams.append('startDate', filters.startDate.toISOString());
//     if (filters.endDate) queryParams.append('endDate', filters.endDate.toISOString());
//     if (filters.search) queryParams.append('search', filters.search);

//     const url = `https://register.iwlf.in/api/admin/athletes/invoices/download?${queryParams}`;
//     const response = await fetch(url, {
//       method: 'GET',
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem('token')}`,
//       },
//     });

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.message || 'Failed to download invoices');
//     }

//     const blob = await response.blob();
//     saveAs(blob, `invoices-${Date.now()}.zip`);
//     toast.success('Invoices downloaded successfully');
//   } catch (error) {
//     console.error('Download error:', error);
//     toast.error(error.message || 'Failed to download invoices');
//   } finally {
//     setDownloadingInvoices(false);
//   }
// };

// Handle individual approve from table
const handleQuickApprove = async (athleteId) => {
  try {
    await adminAPI.verifyAthlete(athleteId, {
      status: 'approved',
      notes: 'Quick approval from table',
    });
    toast.success('Athlete approved successfully');
    fetchAthletes();
  } catch (error) {
    console.error('Approve error:', error);
    toast.error(error.response?.data?.message || 'Approval failed');
  }
};

// Handle individual reject from table
const handleQuickReject = async (athleteId) => {
  try {
    await adminAPI.verifyAthlete(athleteId, {
      status: 'rejected',
      notes: 'Quick rejection from table',
    });
    toast.success('Athlete rejected successfully');
    fetchAthletes();
  } catch (error) {
    console.error('Reject error:', error);
    toast.error(error.response?.data?.message || 'Rejection failed');
  }
};

// Handle delete athlete
const handleDeleteAthlete = async () => {
  if (!deleteAthleteId) return;

  setDeleting(true);
  try {
    const response = await adminAPI.deleteAthlete(deleteAthleteId);
    if (response.data?.warning) {
      toast.warning(response.data.warning, { duration: 5000 });
    } else {
      toast.success('Athlete deleted successfully');
    }
    
    setShowDeleteConfirm(false);
    setDeleteAthleteId(null);
    fetchAthletes();
  } catch (error) {
    console.error('Delete error:', error);
    toast.error(error.response?.data?.message || 'Failed to delete athlete');
  } finally {
    setDeleting(false);
  }
};

// Handle bulk delete
const handleBulkDelete = async () => {
  if (selectedAthletes.length === 0) {
    toast.error('Please select athletes to delete');
    return;
  }

  const confirmed = window.confirm(
    `Are you sure you want to delete ${selectedAthletes.length} athlete(s)? This action cannot be undone and may affect admit card numbering.`
  );

  if (!confirmed) return;

  try {
    const response = await adminAPI.bulkDeleteAthletes(selectedAthletes);
    
    if (response.data?.warning) {
      toast.warning(response.data.warning, { duration: 5000 });
    }
    
    toast.success(response.message);
    setSelectedAthletes([]);
    fetchAthletes();
  } catch (error) {
    console.error('Bulk delete error:', error);
    toast.error(error.response?.data?.message || 'Bulk delete failed');
  }
};

  const handleVerifyAthlete = async (athleteId, status) => {
    try {
      await adminAPI.verifyAthlete(athleteId, {
        status,
        notes: verificationNotes,
      });
      toast.success(`Athlete ${status} successfully`);
      setShowModal(false);
      setVerificationNotes('');
      fetchAthletes();
    } catch (error) {
      console.error('Verification error:', error);
      toast.error(error.response?.data?.message || 'Verification failed');
    }
  };

  const handleBulkVerify = async (status) => {
    if (selectedAthletes.length === 0) {
      toast.error('Please select athletes to verify');
      return;
    }

    try {
      await adminAPI.bulkVerifyAthletes({
        athleteIds: selectedAthletes,
        status,
        notes: verificationNotes,
      });
      toast.success(`${selectedAthletes.length} athletes ${status} successfully`);
      setSelectedAthletes([]);
      setShowVerificationModal(false);
      setVerificationNotes('');
      fetchAthletes();
    } catch (error) {
      console.error('Bulk verification error:', error);
      toast.error('Bulk verification failed');
    }
  };

  const handleUpdateMedicalAge = async (athleteId) => {
    if (!medicalAge || medicalAge < 0 || medicalAge > 150) {
      toast.error('Please enter a valid medical age (0-150)');
      return;
    }

    setUpdatingMedicalAge(true);
    try {
      await adminAPI.updateMedicalAge(athleteId, {
        medicalAge: Number(medicalAge),
      });
      toast.success('Medical age updated successfully');
      const response = await adminAPI.getAthleteDetails(athleteId);
      setSelectedAthlete(response.data);
    } catch (error) {
      console.error('Medical age update error:', error);
      toast.error(error.response?.data?.message || 'Failed to update medical age');
    } finally {
      setUpdatingMedicalAge(false);
    }
  };
const handleExportCSV = async () => {
  setExporting(true);
  try {
    const queryParams = new URLSearchParams();
    if (filters.registrationType !== 'all') {
      queryParams.append('registrationType', filters.registrationType);
    }
    if (filters.verificationStatus !== 'all') {
      queryParams.append('verificationStatus', filters.verificationStatus);
    }
    if (filters.paymentStatus !== 'all') {
      queryParams.append('paymentStatus', filters.paymentStatus);
    }
    if (filters.state !== 'all') {
      queryParams.append('state', filters.state);
    }
    if (filters.eventId !== 'all') {
      queryParams.append('eventId', filters.eventId);
    }
    if (filters.startDate) {
      queryParams.append('startDate', filters.startDate);
    }
    if (filters.endDate) {
      queryParams.append('endDate', filters.endDate);
    }

    const url = `https://register.iwlf.in/api/admin/athletes/export${
      queryParams.toString() ? `?${queryParams}` : ''
    }`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Export failed');
    }

    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = `athletes-export-${Date.now()}.csv`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(downloadUrl);
    document.body.removeChild(a);
    toast.success('Data exported successfully');
  } catch (error) {
    console.error('Export error:', error);
    toast.error(error.message || 'Failed to export data');
  } finally {
    setExporting(false);
  }
};

const handleDownloadInvoices = async () => {
  setDownloadingInvoices(true);
  try {
    const queryParams = new URLSearchParams();
    if (filters.registrationType !== 'all') queryParams.append('registrationType', filters.registrationType);
    if (filters.verificationStatus !== 'all') queryParams.append('verificationStatus', filters.verificationStatus);
    if (filters.paymentStatus !== 'all') queryParams.append('paymentStatus', filters.paymentStatus);
    if (filters.state !== 'all') queryParams.append('state', filters.state);
    if (filters.eventId !== 'all') queryParams.append('eventId', filters.eventId);
    if (filters.startDate) queryParams.append('startDate', filters.startDate);
    if (filters.endDate) queryParams.append('endDate', filters.endDate);
    if (filters.search) queryParams.append('search', filters.search);

    const url = `https://register.iwlf.in/api/admin/athletes/invoices/download?${queryParams}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to download invoices');
    }

    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = `invoices-${Date.now()}.zip`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(downloadUrl);
    document.body.removeChild(a);
    toast.success('Invoices downloaded successfully');
  } catch (error) {
    console.error('Download error:', error);
    toast.error(error.message || 'Failed to download invoices');
  } finally {
    setDownloadingInvoices(false);
  }
};

  const handleImageView = (imageUrl, title) => {
    setCurrentImage({ url: imageUrl, title });
    setShowImageModal(true);
  };

  const handleImageDownload = async (imageUrl, filename) => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || 'download';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      toast.success('File downloaded successfully');
    } catch (error) {
      console.error('Download error:', error);
      toast.error('Failed to download image');
    }
  };

  const toggleAthleteSelection = (athleteId) => {
    setSelectedAthletes((prev) =>
      prev.includes(athleteId)
        ? prev.filter((id) => id !== athleteId)
        : [...prev, athleteId]
    );
  };

  const toggleSelectAll = () => {
    if (selectedAthletes.length === athletes.length) {
      setSelectedAthletes([]);
    } else {
      setSelectedAthletes(athletes.map((a) => a._id));
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      pending: 'warning',
      approved: 'success',
      rejected: 'error',
      completed: 'success',
      failed: 'error',
    };
    return colors[status] || 'default';
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  const handleEditAthlete = () => {
  setEditingAthlete(true);
  setEditFormData({
    firstName: selectedAthlete.firstName || '',
    middleName: selectedAthlete.middleName || '',
    surname: selectedAthlete.surname || '',
    email: selectedAthlete.email || '',
    phoneNumber: selectedAthlete.phoneNumber || '',
    bloodGroup: selectedAthlete.bloodGroup || '',
    district: selectedAthlete.district || '',
    stateDepartment: selectedAthlete.stateDepartment || '',
    addressLine1: selectedAthlete.addressLine1 || '',
    addressLine2: selectedAthlete.addressLine2 || '',
    city: selectedAthlete.city || '',
    state: selectedAthlete.state || '',
    pincode: selectedAthlete.pincode || '',
  });
};

const handleSaveEdit = async () => {
  // Validation
  if (!editFormData.firstName || !editFormData.surname) {
    toast.error('First name and surname are required');
    return;
  }

  if (!editFormData.email) {
    toast.error('Email is required');
    return;
  }

  // Email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(editFormData.email)) {
    toast.error('Invalid email format');
    return;
  }

  // Phone validation
  if (editFormData.phoneNumber) {
    const phoneRegex = /^[6-9]\d{9}$/;
    if (!phoneRegex.test(editFormData.phoneNumber)) {
      toast.error('Invalid phone number format');
      return;
    }
  }

  try {
    setUpdatingMedicalAge(true); // Reuse this loading state
    
    await adminAPI.updateAthleteDetails(selectedAthlete._id, editFormData);
    
    toast.success('Athlete details updated successfully');
    setEditingAthlete(false);
    
    // Refresh athlete details
    const response = await adminAPI.getAthleteDetails(selectedAthlete._id);
    setSelectedAthlete(response.data);
    
    // Refresh the athletes list
    fetchAthletes();
  } catch (error) {
    console.error('Update error:', error);
    toast.error(error.response?.data?.message || 'Failed to update athlete details');
  } finally {
    setUpdatingMedicalAge(false);
  }
};

const handleCancelEdit = () => {
  setEditingAthlete(false);
  setEditFormData({});
};

  if (loading && athletes.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh' }}>

      <Container maxWidth="xl" sx={{ py: 4 }}>
        {/* Header */}
        <Paper sx={{ p: 3, mb: 3 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Athletes List
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Manage and verify athlete registrations
          </Typography>

          {/* Filters */}
<Grid container spacing={2} sx={{ mb: 3 }}>
  <Grid item xs={12} md={3}>
    <TextField
      fullWidth
      size="small"
      placeholder="Search by name, email, phone..."
      value={searchInput}
      onChange={(e) => setSearchInput(e.target.value)}
      onKeyPress={(e) => e.key === 'Enter' && handleSearch(e)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
    />
  </Grid>
  
  <Grid item xs={12} md={2}>
    <FormControl fullWidth size="small">
      <InputLabel>Type</InputLabel>
      <Select
        value={filters.registrationType}
        label="Type"
        onChange={(e) => handleFilterChange('registrationType', e.target.value)}
      >
        <MenuItem value="all">All Types</MenuItem>
        <MenuItem value="youth">Youth</MenuItem>
        <MenuItem value="junior">Junior</MenuItem>
        <MenuItem value="senior">Senior</MenuItem>
      </Select>
    </FormControl>
  </Grid>

  <Grid item xs={12} md={2}>
    <FormControl fullWidth size="small">
      <InputLabel>Status</InputLabel>
      <Select
        value={filters.verificationStatus}
        label="Status"
        onChange={(e) => handleFilterChange('verificationStatus', e.target.value)}
      >
        <MenuItem value="all">All Status</MenuItem>
        <MenuItem value="pending">Pending</MenuItem>
        <MenuItem value="approved">Approved</MenuItem>
        <MenuItem value="rejected">Rejected</MenuItem>
      </Select>
    </FormControl>
  </Grid>

  <Grid item xs={12} md={2}>
    <FormControl fullWidth size="small">
      <InputLabel>Payment</InputLabel>
      <Select
        value={filters.paymentStatus}
        label="Payment"
        onChange={(e) => handleFilterChange('paymentStatus', e.target.value)}
      >
        <MenuItem value="all">All Payments</MenuItem>
        <MenuItem value="completed">Completed</MenuItem>
        <MenuItem value="pending">Pending</MenuItem>
        <MenuItem value="failed">Failed</MenuItem>
      </Select>
    </FormControl>
  </Grid>

  <Grid item xs={12} md={2}>
    <FormControl fullWidth size="small">
      <InputLabel>State</InputLabel>
      <Select
        value={filters.state}
        label="State"
        onChange={(e) => handleFilterChange('state', e.target.value)}
      >
        <MenuItem value="all">All States</MenuItem>
        {states.slice(1).map((state) => (
          <MenuItem key={state} value={state}>{state}</MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>

  <Grid item xs={12} md={3}>
    <FormControl fullWidth size="small">
      <InputLabel>Event</InputLabel>
      <Select
        value={filters.eventId}
        label="Event"
        onChange={(e) => handleFilterChange('eventId', e.target.value)}
      >
        <MenuItem value="all">All Events</MenuItem>
        {events.map((event) => (
          <MenuItem key={event._id} value={event._id}>{event.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>

  <Grid item xs={12} md={2}>
  <TextField
    fullWidth
    size="small"
    label="Start Date"
    type="date"
    value={filters.startDate || ''}
    onChange={(e) => handleFilterChange('startDate', e.target.value)}
    InputLabelProps={{
      shrink: true,
    }}
  />
</Grid>

<Grid item xs={12} md={2}>
  <TextField
    fullWidth
    size="small"
    label="End Date"
    type="date"
    value={filters.endDate || ''}
    onChange={(e) => handleFilterChange('endDate', e.target.value)}
    InputLabelProps={{
      shrink: true,
    }}
  />
</Grid>

  <Grid item xs={12} md={2}>
    <Button
      variant="contained"
      onClick={handleSearch}
      fullWidth
      size="large"
      sx={{ height: '40px' }}
    >
      Search
    </Button>
  </Grid>

  <Grid item xs={12} md={2}>
    <Button
      variant="outlined"
      startIcon={<GetApp />}
      onClick={handleExportCSV}
      disabled={exporting}
      fullWidth
      size="large"
      sx={{ height: '40px' }}
    >
      {exporting ? <CircularProgress size={20} /> : 'Export CSV'}
    </Button>
  </Grid>

  <Grid item xs={12} md={2}>
    <Button
      variant="outlined"
      color="secondary"
      startIcon={<Download />}
      onClick={handleDownloadInvoices}
      disabled={downloadingInvoices}
      fullWidth
      size="large"
      sx={{ height: '40px' }}
    >
      {downloadingInvoices ? <CircularProgress size={20} /> : 'Download Invoices'}
    </Button>
  </Grid>
</Grid>
        </Paper>

        {/* Bulk Actions */}
        {selectedAthletes.length > 0 && (
  <Card sx={{ mb: 2, backgroundColor: '#f5f5f5' }}>
    <CardContent>
      <Stack direction="row" spacing={2} alignItems="center">
        <Typography variant="body1" fontWeight="bold">
          {selectedAthletes.length} athlete(s) selected
        </Typography>
        
        <Button
          variant="contained"
          color="success"
          startIcon={<ThumbUp />}
          onClick={() => setShowVerificationModal(true)}
        >
          Bulk Approve
        </Button>
        
        <Button
          variant="contained"
          color="error"
          startIcon={<ThumbDown />}
          onClick={() => {
            setShowVerificationModal(true);
          }}
        >
          Bulk Reject
        </Button>
        
        <Button
          variant="outlined"
          color="error"
          startIcon={<Delete />}
          onClick={handleBulkDelete}
        >
          Delete Selected
        </Button>
        
        <Button
          variant="outlined"
          onClick={() => setSelectedAthletes([])}
        >
          Clear Selection
        </Button>
      </Stack>
    </CardContent>
  </Card>
)}

        {/* Athletes Table */}
        <Paper>
          <TableContainer>
            <Table>
              <TableHead>
  <TableRow>
    <TableCell padding="checkbox">
      <Checkbox
        checked={
          selectedAthletes.length > 0 &&
          selectedAthletes.length === athletes.length
        }
        onChange={toggleSelectAll}
        indeterminate={
          selectedAthletes.length > 0 &&
          selectedAthletes.length < athletes.length
        }
      />
    </TableCell>
    <TableCell>Athlete</TableCell>
    <TableCell>Type</TableCell>
    <TableCell>Contact</TableCell>
    <TableCell>City</TableCell>
    <TableCell>State</TableCell>
    <TableCell>Event</TableCell>
    <TableCell>Payment</TableCell>
    <TableCell>Status</TableCell>
    <TableCell>Medical Age</TableCell>
    <TableCell>Registered</TableCell>
    <TableCell>Actions</TableCell>
  </TableRow>
</TableHead>
              <TableBody>
                {athletes.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center" sx={{ py: 8 }}>
                      <Typography variant="h6" color="text.secondary">
                        No athletes found
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Try adjusting your filters
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  athletes.map((athlete) => (
                   <TableRow key={athlete._id} hover>
    <TableCell padding="checkbox">
      <Checkbox
        checked={selectedAthletes.includes(athlete._id)}
        onChange={() => toggleAthleteSelection(athlete._id)}
      />
    </TableCell>
    <TableCell>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {athlete.photo?.path ? (
          <Avatar
            src={`https://register.iwlf.in/${athlete.photo.path}`}
            onClick={() =>
              handleImageView(
                `https://register.iwlf.in/${athlete.photo.path}`,
                'Athlete Photo'
              )
            }
            sx={{ cursor: 'pointer' }}
          />
        ) : (
          <Avatar>
            {athlete.firstName?.charAt(0)}
            {athlete.surname?.charAt(0)}
          </Avatar>
        )}
        <Box>
          <Typography variant="body2" fontWeight="bold">
            {athlete.firstName} {athlete.middleName}{' '}
            {athlete.surname}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {athlete.email}
          </Typography>
        </Box>
      </Box>
    </TableCell>
    <TableCell>
      <Chip
        label={athlete.registrationType}
        size="small"
        color="primary"
        variant="outlined"
      />
    </TableCell>
    <TableCell>
      <Typography variant="body2">{athlete.phoneNumber}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="body2">{athlete.city || '-'}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="body2">{athlete.state || '-'}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="body2" sx={{ maxWidth: 150 }}>
        {athlete.selectedEvent?.eventName || '-'}
      </Typography>
    </TableCell>
    <TableCell>
      <Box>
        <Chip
          label={athlete.paymentStatus.toUpperCase()}
          size="small"
          color={getStatusColor(athlete.paymentStatus)}
        />
        {athlete.amount && (
          <Typography variant="caption" display="block">
            ₹{(athlete.amount / 100).toFixed(2)}
          </Typography>
        )}
      </Box>
    </TableCell>
    <TableCell>
      <Chip
        label={athlete.verificationStatus.toUpperCase()}
        size="small"
        color={getStatusColor(athlete.verificationStatus)}
      />
    </TableCell>
    <TableCell>
      <Typography variant="body2">{athlete.medicalAge || '-'}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="body2">
        {formatDate(athlete.createdAt)}
      </Typography>
    </TableCell>
    <TableCell>
  <Stack direction="row" spacing={1}>
    <Tooltip title="View Details">
      <IconButton
        size="small"
        color="primary"
        onClick={() => handleViewDetails(athlete._id)}
      >
        <Visibility />
      </IconButton>
    </Tooltip>
    
    {athlete.verificationStatus === 'pending' && (
      <>
        <Tooltip title="Approve">
          <IconButton
            size="small"
            color="success"
            onClick={() => handleQuickApprove(athlete._id)}
          >
            <ThumbUp fontSize="small" />
          </IconButton>
        </Tooltip>
        
        <Tooltip title="Reject">
          <IconButton
            size="small"
            color="error"
            onClick={() => handleQuickReject(athlete._id)}
          >
            <ThumbDown fontSize="small" />
          </IconButton>
        </Tooltip>
      </>
    )}
    
    <Tooltip title="Delete Athlete">
      <IconButton
        size="small"
        color="error"
        onClick={() => {
          setDeleteAthleteId(athlete._id);
          setShowDeleteConfirm(true);
        }}
      >
        <Delete fontSize="small" />
      </IconButton>
    </Tooltip>
  </Stack>
</TableCell>
  </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <TablePagination
            component="div"
            count={pagination.totalRecords || 0}
            page={(pagination.currentPage || 1) - 1}
            onPageChange={(e, newPage) =>
              handleFilterChange('page', newPage + 1)
            }
            rowsPerPage={filters.limit}
            onRowsPerPageChange={(e) =>
              handleFilterChange('limit', parseInt(e.target.value))
            }
            rowsPerPageOptions={[10, 20, 50, 100]}
          />
        </Paper>
      </Container>

      {/* Athlete Details Modal */}
      <Dialog
        open={showModal}
        onClose={() => {
          setShowModal(false);
          setEditingAthlete(false);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Athlete Details</Typography>
            <IconButton onClick={() => setShowModal(false)}>
              <Close />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent dividers>
          {selectedAthlete && (
            <Box>
              {/* Photo Section */}
              <Box sx={{ textAlign: 'center', mb: 3 }}>
                {selectedAthlete.photo?.path ? (
                  <Avatar
                    src={`https://register.iwlf.in/${selectedAthlete.photo.path}`}
                    sx={{ width: 120, height: 120, mx: 'auto', mb: 2, cursor: 'pointer' }}
                    onClick={() =>
                      handleImageView(
                        `https://register.iwlf.in/${selectedAthlete.photo.path}`,
                        'Athlete Photo'
                      )
                    }
                  />
                ) : (
                  <Avatar sx={{ width: 120, height: 120, mx: 'auto', mb: 2 }}>
                    <Person sx={{ fontSize: 60 }} />
                  </Avatar>
                )}
              </Box>

              {/* Personal Information */}
              <Typography variant="h6" gutterBottom>
                Personal Information
              </Typography>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="First Name"
                    value={editingAthlete ? editFormData.firstName : selectedAthlete.firstName}
                    onChange={(e) =>
                      setEditFormData({ ...editFormData, firstName: e.target.value })
                    }
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Middle Name"
                    value={editingAthlete ? editFormData.middleName : selectedAthlete.middleName}
                    onChange={(e) =>
                      setEditFormData({ ...editFormData, middleName: e.target.value })
                    }
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Surname"
                    value={editingAthlete ? editFormData.surname : selectedAthlete.surname}
                    onChange={(e) =>
                      setEditFormData({ ...editFormData, surname: e.target.value })
                    }
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Email"
                    value={editingAthlete ? editFormData.email : selectedAthlete.email}
                    onChange={(e) =>
                      setEditFormData({ ...editFormData, email: e.target.value })
                    }
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Phone Number"
                    value={
                      editingAthlete ? editFormData.phoneNumber : selectedAthlete.phoneNumber
                    }
                    onChange={(e) =>
                      setEditFormData({ ...editFormData, phoneNumber: e.target.value })
                    }
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Gender"
                    value={selectedAthlete.gender}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Birth Date"
                    value={formatDate(selectedAthlete.birthDate)}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Blood Group"
                    value={
                      editingAthlete ? editFormData.bloodGroup : selectedAthlete.bloodGroup
                    }
                    onChange={(e) =>
                      setEditFormData({ ...editFormData, bloodGroup: e.target.value })
                    }
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Aadhar Number"
                    value={selectedAthlete.aadharCardNumber}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Khelo India ID"
                    value={selectedAthlete.kheloIndiaId || '-'}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="District"
                    value={editingAthlete ? editFormData.district : selectedAthlete.district}
                    onChange={(e) =>
                      setEditFormData({ ...editFormData, district: e.target.value })
                    }
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="State Department"
                    value={
                      editingAthlete
                        ? editFormData.stateDepartment
                        : selectedAthlete.stateDepartment
                    }
                    onChange={(e) =>
                      setEditFormData({ ...editFormData, stateDepartment: e.target.value })
                    }
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
              </Grid>

              <Divider sx={{ my: 2 }} />

              {/* Father's Information */}
              <Typography variant="h6" gutterBottom>
                Father's Information
              </Typography>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="First Name"
                    value={selectedAthlete.fatherFirstName}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Middle Name"
                    value={selectedAthlete.fatherMiddleName || '-'}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Surname"
                    value={selectedAthlete.fatherSurname}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
              </Grid>

              {selectedAthlete.motherFirstName && (
                <>
                  <Divider sx={{ my: 2 }} />
                  <Typography variant="h6" gutterBottom>
                    Mother's Information
                  </Typography>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="First Name"
                        value={selectedAthlete.motherFirstName || '-'}
                        disabled={!editingAthlete}
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Middle Name"
                        value={selectedAthlete.motherMiddleName || '-'}
                        disabled={!editingAthlete}
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Surname"
                        value={selectedAthlete.motherSurname || '-'}
                        disabled={!editingAthlete}
                        size="small"
                      />
                    </Grid>
                  </Grid>
                </>
              )}

              <Divider sx={{ my: 2 }} />

              {/* Address */}
              <Typography variant="h6" gutterBottom>
                Address
              </Typography>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Address Line 1"
                    value={selectedAthlete.addressLine1}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                {selectedAthlete.addressLine2 && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Address Line 2"
                      value={selectedAthlete.addressLine2}
                      disabled={!editingAthlete}
                      size="small"
                    />
                  </Grid>
                )}
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="City"
                    value={selectedAthlete.city}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="State"
                    value={selectedAthlete.state}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Pincode"
                    value={selectedAthlete.pincode}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
              </Grid>

              <Divider sx={{ my: 2 }} />

              {/* Event & Payment */}
              <Typography variant="h6" gutterBottom>
                Event & Payment Details
              </Typography>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Event Name"
                    value={selectedAthlete.selectedEvent?.eventName || '-'}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Registration Type"
                    value={selectedAthlete.registrationType?.toUpperCase()}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Payment Status"
                    value={selectedAthlete.paymentStatus?.toUpperCase()}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Amount"
                    value={
                      selectedAthlete.amount
                        ? `₹${(selectedAthlete.amount / 100).toFixed(2)}`
                        : '-'
                    }
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Payment Date"
                    value={formatDate(selectedAthlete.paymentDate)}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Payment ID"
                    value={selectedAthlete.paymentId || '-'}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Invoice Number"
                    value={selectedAthlete.invoiceNumber || '-'}
                    disabled={!editingAthlete}
                    size="small"
                  />
                </Grid>
              </Grid>

              <Divider sx={{ my: 2 }} />

              {/* Medical Age (for Junior/Youth only) */}
              {['junior', 'youth'].includes(selectedAthlete.registrationType) && (
                <>
                  <Typography variant="h6" gutterBottom>
                    Medical Information
                  </Typography>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={8}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Medical Age"
                        value={medicalAge}
                        onChange={(e) => setMedicalAge(e.target.value)}
                        placeholder="Enter medical age"
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <MedicalServices />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={() => handleUpdateMedicalAge(selectedAthlete._id)}
                        disabled={updatingMedicalAge}
                      >
                        {updatingMedicalAge ? <CircularProgress size={20} /> : 'Update'}
                      </Button>
                    </Grid>
                    {selectedAthlete.medicalAge && (
                      <Grid item xs={12}>
                        <Typography variant="caption" color="text.secondary">
                          Current Medical Age: {selectedAthlete.medicalAge} years
                          {selectedAthlete.medicalAgeFilledAt && (
                            <> (Updated: {formatDate(selectedAthlete.medicalAgeFilledAt)})</>
                          )}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>

                  {selectedAthlete.medicalCertificate?.path && (
  <Box sx={{ mb: 3 }}>
    <Card variant="outlined">
      <CardContent>
        <Typography variant="subtitle2" gutterBottom>
          Medical Certificate (PDF)
        </Typography>
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
          {selectedAthlete.medicalCertificate.filename}
        </Typography>
        
        <Stack direction="row" spacing={1}>
          <Button
            variant="outlined"
            size="small"
            startIcon={<Image />}
            onClick={() =>
              window.open(
                `https://register.iwlf.in/${selectedAthlete.medicalCertificate.path}`,
                '_blank'
              )
            }
          >
            Open Medical Certificate
          </Button>
          <Button
            variant="outlined"
            size="small"
            startIcon={<Download />}
            onClick={() =>
              handleImageDownload(
                `https://register.iwlf.in/${selectedAthlete.medicalCertificate.path}`,
                selectedAthlete.medicalCertificate.filename || 'medical-certificate.pdf'
              )
            }
          >
            Download
          </Button>
        </Stack>
      </CardContent>
    </Card>
  </Box>
)}
                  <Divider sx={{ my: 2 }} />
                </>
              )}

              {/* Documents */}
<Divider sx={{ my: 2 }} />

{/* Documents */}
<Typography variant="h6" gutterBottom>
  Documents
</Typography>
<Grid container spacing={2} sx={{ mb: 2 }}>
  {/* Identity Proof */}
  {selectedAthlete.identityProof?.front?.path && (
    <Grid item xs={12} md={6}>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="subtitle2" gutterBottom>
            Identity Proof - Front
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
            {selectedAthlete.identityProof.type}
          </Typography>
          
          {/* Thumbnail Image */}
          <Box
            component="img"
            src={`https://register.iwlf.in/${selectedAthlete.identityProof.front.path}`}
            alt="Identity Proof - Front"
            sx={{
              width: '100%',
              height: 200,
              objectFit: 'cover',
              borderRadius: 1,
              mb: 2,
              cursor: 'pointer',
              border: '1px solid #e0e0e0',
              '&:hover': {
                opacity: 0.8,
                transform: 'scale(1.02)',
                transition: 'all 0.3s ease',
              },
            }}
            onClick={() =>
              handleImageView(
                `https://register.iwlf.in/${selectedAthlete.identityProof.front.path}`,
                'Identity Proof - Front'
              )
            }
          />
          
          <Stack direction="row" spacing={1}>
            <Button
              size="small"
              variant="outlined"
              startIcon={<Visibility />}
              fullWidth
              onClick={() =>
                handleImageView(
                  `https://register.iwlf.in/${selectedAthlete.identityProof.front.path}`,
                  'Identity Proof - Front'
                )
              }
            >
              View Full Size
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Grid>
  )}

  {selectedAthlete.identityProof?.back?.path && (
    <Grid item xs={12} md={6}>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="subtitle2" gutterBottom>
            Identity Proof - Back
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
            {selectedAthlete.identityProof.type}
          </Typography>
          
          {/* Thumbnail Image */}
          <Box
            component="img"
            src={`https://register.iwlf.in/${selectedAthlete.identityProof.back.path}`}
            alt="Identity Proof - Back"
            sx={{
              width: '100%',
              height: 200,
              objectFit: 'cover',
              borderRadius: 1,
              mb: 2,
              cursor: 'pointer',
              border: '1px solid #e0e0e0',
              '&:hover': {
                opacity: 0.8,
                transform: 'scale(1.02)',
                transition: 'all 0.3s ease',
              },
            }}
            onClick={() =>
              handleImageView(
                `https://register.iwlf.in/${selectedAthlete.identityProof.back.path}`,
                'Identity Proof - Back'
              )
            }
          />
          
          <Stack direction="row" spacing={1}>
            <Button
              size="small"
              variant="outlined"
              startIcon={<Visibility />}
              fullWidth
              onClick={() =>
                handleImageView(
                  `https://register.iwlf.in/${selectedAthlete.identityProof.back.path}`,
                  'Identity Proof - Back'
                )
              }
            >
              View Full Size
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Grid>
  )}

  {/* Proof of Age */}
  {selectedAthlete.proofOfAge?.front?.path && (
    <Grid item xs={12} md={6}>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="subtitle2" gutterBottom>
            Proof of Age - Front
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
            {selectedAthlete.proofOfAge.type}
          </Typography>
          
          {/* Thumbnail Image */}
          <Box
            component="img"
            src={`https://register.iwlf.in/${selectedAthlete.proofOfAge.front.path}`}
            alt="Proof of Age - Front"
            sx={{
              width: '100%',
              height: 200,
              objectFit: 'cover',
              borderRadius: 1,
              mb: 2,
              cursor: 'pointer',
              border: '1px solid #e0e0e0',
              '&:hover': {
                opacity: 0.8,
                transform: 'scale(1.02)',
                transition: 'all 0.3s ease',
              },
            }}
            onClick={() =>
              handleImageView(
                `https://register.iwlf.in/${selectedAthlete.proofOfAge.front.path}`,
                'Proof of Age - Front'
              )
            }
          />
          
          <Stack direction="row" spacing={1}>
            <Button
              size="small"
              variant="outlined"
              startIcon={<Visibility />}
              fullWidth
              onClick={() =>
                handleImageView(
                  `https://register.iwlf.in/${selectedAthlete.proofOfAge.front.path}`,
                  'Proof of Age - Front'
                )
              }
            >
              View Full Size
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Grid>
  )}

  {selectedAthlete.proofOfAge?.back?.path && (
    <Grid item xs={12} md={6}>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="subtitle2" gutterBottom>
            Proof of Age - Back
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
            {selectedAthlete.proofOfAge.type}
          </Typography>
          
          {/* Thumbnail Image */}
          <Box
            component="img"
            src={`https://register.iwlf.in/${selectedAthlete.proofOfAge.back.path}`}
            alt="Proof of Age - Back"
            sx={{
              width: '100%',
              height: 200,
              objectFit: 'cover',
              borderRadius: 1,
              mb: 2,
              cursor: 'pointer',
              border: '1px solid #e0e0e0',
              '&:hover': {
                opacity: 0.8,
                transform: 'scale(1.02)',
                transition: 'all 0.3s ease',
              },
            }}
            onClick={() =>
              handleImageView(
                `https://register.iwlf.in/${selectedAthlete.proofOfAge.back.path}`,
                'Proof of Age - Back'
              )
            }
          />
          
          <Stack direction="row" spacing={1}>
            <Button
              size="small"
              variant="outlined"
              startIcon={<Visibility />}
              fullWidth
              onClick={() =>
                handleImageView(
                  `https://register.iwlf.in/${selectedAthlete.proofOfAge.back.path}`,
                  'Proof of Age - Back'
                )
              }
            >
              View Full Size
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Grid>
  )}

  {/* Address Proof */}
  {selectedAthlete.addressProof?.front?.path && (
    <Grid item xs={12} md={6}>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="subtitle2" gutterBottom>
            Address Proof - Front
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
            {selectedAthlete.addressProof.type}
          </Typography>
          
          {/* Thumbnail Image */}
          <Box
            component="img"
            src={`https://register.iwlf.in/${selectedAthlete.addressProof.front.path}`}
            alt="Address Proof - Front"
            sx={{
              width: '100%',
              height: 200,
              objectFit: 'cover',
              borderRadius: 1,
              mb: 2,
              cursor: 'pointer',
              border: '1px solid #e0e0e0',
              '&:hover': {
                opacity: 0.8,
                transform: 'scale(1.02)',
                transition: 'all 0.3s ease',
              },
            }}
            onClick={() =>
              handleImageView(
                `https://register.iwlf.in/${selectedAthlete.addressProof.front.path}`,
                'Address Proof - Front'
              )
            }
          />
          
          <Stack direction="row" spacing={1}>
            <Button
              size="small"
              variant="outlined"
              startIcon={<Visibility />}
              fullWidth
              onClick={() =>
                handleImageView(
                  `https://register.iwlf.in/${selectedAthlete.addressProof.front.path}`,
                  'Address Proof - Front'
                )
              }
            >
              View Full Size
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Grid>
  )}

  {selectedAthlete.addressProof?.back?.path && (
    <Grid item xs={12} md={6}>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="subtitle2" gutterBottom>
            Address Proof - Back
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
            {selectedAthlete.addressProof.type}
          </Typography>
          
          {/* Thumbnail Image */}
          <Box
            component="img"
            src={`https://register.iwlf.in/${selectedAthlete.addressProof.back.path}`}
            alt="Address Proof - Back"
            sx={{
              width: '100%',
              height: 200,
              objectFit: 'cover',
              borderRadius: 1,
              mb: 2,
              cursor: 'pointer',
              border: '1px solid #e0e0e0',
              '&:hover': {
                opacity: 0.8,
                transform: 'scale(1.02)',
                transition: 'all 0.3s ease',
              },
            }}
            onClick={() =>
              handleImageView(
                `https://register.iwlf.in/${selectedAthlete.addressProof.back.path}`,
                'Address Proof - Back'
              )
            }
          />
          
          <Stack direction="row" spacing={1}>
            <Button
              size="small"
              variant="outlined"
              startIcon={<Visibility />}
              fullWidth
              onClick={() =>
                handleImageView(
                  `https://register.iwlf.in/${selectedAthlete.addressProof.back.path}`,
                  'Address Proof - Back'
                )
              }
            >
              View Full Size
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Grid>
  )}
</Grid>


              <Divider sx={{ my: 2 }} />

              {/* Verification */}
              <Typography variant="h6" gutterBottom>
                Verification
              </Typography>
              <Box sx={{ mb: 2 }}>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  label="Verification Notes"
                  value={verificationNotes}
                  onChange={(e) => setVerificationNotes(e.target.value)}
                  placeholder="Add notes for verification (optional)"
                />
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          {selectedAthlete && (
            <>
              {editingAthlete ? (
                <>
                  <Button onClick={() => setEditingAthlete(false)}>Cancel Edit</Button>
                  <Button variant="contained" onClick={handleSaveEdit}>
                    Save Changes
                  </Button>
                </>
              ) : (
                <>
                  <Button onClick={() => setShowModal(false)}>Close</Button>
                  <Button
                    startIcon={<Edit />}
                    onClick={handleEditAthlete}
                    variant="outlined"
                  >
                    Edit Details
                  </Button>
                  {selectedAthlete.verificationStatus === 'pending' && (
                    <>
                      <Button
                        variant="contained"
                        color="error"
                        startIcon={<Cancel />}
                        onClick={() =>
                          handleVerifyAthlete(selectedAthlete._id, 'rejected')
                        }
                      >
                        Reject
                      </Button>
                      <Button
                        variant="contained"
                        color="success"
                        startIcon={<CheckCircle />}
                        onClick={() =>
                          handleVerifyAthlete(selectedAthlete._id, 'approved')
                        }
                      >
                        Approve
                      </Button>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </DialogActions>
      </Dialog>

      {/* Image Preview Modal */}
      <Dialog
        open={showImageModal}
        onClose={() => setShowImageModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{currentImage?.title}</Typography>
            <IconButton onClick={() => setShowImageModal(false)}>
              <Close />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent>
          {currentImage && (
            <Box sx={{ textAlign: 'center' }}>
              <img
                src={currentImage.url}
                alt={currentImage.title}
                style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            startIcon={<Download />}
            onClick={() =>
              handleImageDownload(currentImage?.url, currentImage?.title)
            }
          >
            Download
          </Button>
          <Button onClick={() => setShowImageModal(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Bulk Verification Modal */}
      <Dialog
        open={showVerificationModal}
        onClose={() => setShowVerificationModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Bulk Verification</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            You are about to verify {selectedAthletes.length} athlete(s).
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Verification Notes"
            value={verificationNotes}
            onChange={(e) => setVerificationNotes(e.target.value)}
            placeholder="Add notes for bulk verification (optional)"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowVerificationModal(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => handleBulkVerify('rejected')}
          >
            Reject All
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={() => handleBulkVerify('approved')}
          >
            Approve All
          </Button>
        </DialogActions>
      </Dialog>
      {/* Delete Confirmation Modal */}
<Dialog
  open={showDeleteConfirm}
  onClose={() => setShowDeleteConfirm(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>Confirm Delete</DialogTitle>
  <DialogContent>
    <Typography variant="body1" gutterBottom>
      Are you sure you want to delete this athlete?
    </Typography>
    <Typography variant="body2" color="error" sx={{ mt: 2 }}>
      ⚠️ Warning: This action cannot be undone. If this athlete has an admit
      card number, deleting them may cause issues with the admit card numbering
      sequence.
    </Typography>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setShowDeleteConfirm(false)} disabled={deleting}>
      Cancel
    </Button>
    <Button
      onClick={handleDeleteAthlete}
      color="error"
      variant="contained"
      disabled={deleting}
      startIcon={deleting ? <CircularProgress size={20} /> : <Delete />}
    >
      {deleting ? 'Deleting...' : 'Delete'}
    </Button>
  </DialogActions>
</Dialog>

<Dialog
  open={showVerificationModal}
  onClose={() => setShowVerificationModal(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>Bulk Verification</DialogTitle>
  <DialogContent>
    <Typography gutterBottom>
      You are about to verify {selectedAthletes.length} athlete(s).
    </Typography>
    <TextField
      fullWidth
      multiline
      rows={3}
      label="Verification Notes (Optional)"
      value={verificationNotes}
      onChange={(e) => setVerificationNotes(e.target.value)}
      placeholder="Add notes for bulk verification (optional)"
      sx={{ mt: 2 }}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setShowVerificationModal(false)}>Cancel</Button>
    <Button
      onClick={() => handleBulkVerify('rejected')}
      color="error"
      variant="outlined"
      startIcon={<ThumbDown />}
    >
      Reject All
    </Button>
    <Button
      onClick={() => handleBulkVerify('approved')}
      color="success"
      variant="contained"
      startIcon={<ThumbUp />}
    >
      Approve All
    </Button>
  </DialogActions>
</Dialog>
    </Box>
  );
};

export default AthletesList;